function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b51fee7f-754a-4fa4-ab44-b64d600b2c07{fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "b850daf1-012c-484a-b5bb-9666db76cd6b",
  "data-name": "Details"
}, /*#__PURE__*/React.createElement("g", {
  id: "ab2de6b9-1bc3-4935-9a12-2e70cbebbce0",
  "data-name": "datensatz objekt texte"
}, /*#__PURE__*/React.createElement("path", {
  id: "aaac43af-c617-4221-883e-9a9518bb226a",
  "data-name": "Fill-8",
  className: "b51fee7f-754a-4fa4-ab44-b64d600b2c07",
  d: "M15,7.92c5.91,0,11,6.74,11,7s-5.09,7-11,7-11-6.73-11-7S9.09,7.92,15,7.92Zm0,1.56c-4.28,0-8,4.06-9.13,5.44C7,16.31,10.74,20.37,15,20.37s8-4.06,9.12-5.44C23,13.54,19.27,9.48,15,9.48Zm0,1.15a4.29,4.29,0,1,1-4.29,4.29A4.29,4.29,0,0,1,15,10.63Z"
})));

var SvgIconVisible = function SvgIconVisible(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ba1c7f0e-bf82-45b0-a519-9ede1a85d9a9",
    "data-name": "Icons",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconVisible, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-visible.34a36dd2.svg";
export { ForwardRef as ReactComponent };